import { render, staticRenderFns } from "./PayQrCode.vue?vue&type=template&id=0b7b27c3&scoped=true"
import script from "./PayQrCode.vue?vue&type=script&lang=js"
export * from "./PayQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b27c3",
  null
  
)

export default component.exports